// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { FLOWPAGE_API_ENDPOINT } from '@dtx-company/true-common/src/constants/endpoints'
import { createApi } from '@reduxjs/toolkit/query/react'
import { graphqlRequestBaseQuery } from './utils'

const flowpageApiUrl = FLOWPAGE_API_ENDPOINT

// initialize an empty api service that we'll inject endpoints into later as needed
export const flowpageApi = createApi({
  reducerPath: 'flowpageApi',
  baseQuery: graphqlRequestBaseQuery({
    options: { url: flowpageApiUrl + '/graphql' }
  }),
  tagTypes: [
    'PageDetail',
    'PageGate',
    'accountInfo',
    'highlightedFlowpages',
    'pageCount',
    'pageManagement',
    'templateAssetDetails',
    'pageTemplate',
    'pageTemplates',
    'pageTemplateCount',
    'pageTemplateChildPages',
    'pageBaseTemplate',
    'formList',
    'pageList',
    'submissionList',
    'submissionSummary'
  ],
  endpoints: () => ({})
})
